import type { Route } from 'nextjs-routes';

const TEMPLATE_MAP: Record<Route['pathname'], string> = {
  '/': 'Bittensor Network Block Explorer',
  '/txs': 'transactions',
  '/txs/kettle/[hash]': 'kettle %hash% transactions',
  '/tx/[hash]': 'transaction %hash%',
  '/blocks': 'blocks',
  '/block/[height_or_hash]': 'block %height_or_hash%',
  '/block/countdown': 'block countdown index',
  '/block/countdown/[height]': 'block %height% countdown',
  '/accounts': 'top accounts',
  '/accounts/label/[slug]': 'addresses search by label',
  '/address/[hash]': 'address details for %hash%',
  '/verified-contracts': 'Verified contracts lookup',
  '/contract-verification': 'contract verification',
  '/address/[hash]/contract-verification': 'contract verification for %hash%',
  '/tokens': 'Tokens list',
  '/token/[hash]': 'token details',
  '/token/[hash]/instance/[id]': 'NFT instance',
  '/apps': 'DApps - Explore top apps',
  '/apps/[id]': 'marketplace app',
  '/stats': 'stats',
  '/stats/[id]': 'stats - %id% chart',
  '/api-docs': 'API docs',
  '/graphiql': 'GraphQL',
  '/search-results': 'search result for %q%',
  '/auth/profile': 'my profile',
  '/account/rewards': 'rewards',
  '/account/watchlist': 'watchlist',
  '/account/api-key': 'API keys',
  '/account/custom-abi': 'custom ABI',
  '/account/tag-address': 'private tags',
  '/account/verified-addresses': 'my verified addresses',
  '/public-tags/submit': 'public tag requests',
  '/withdrawals': 'withdrawals',
  '/visualize/sol2uml': 'Solidity UML diagram',
  '/csv-export': 'export data to CSV',
  '/deposits': 'deposits (L1 > L2)',
  '/output-roots': 'output roots',
  '/dispute-games': 'dispute games',
  '/batches': 'txn batches',
  '/batches/[number]': 'L2 txn batch %number%',
  '/blobs/[hash]': 'blob %hash% details',
  '/ops': 'User operations',
  '/op/[hash]': 'user operation %hash%',
  '/404': 'error - page not found',
  '/name-domains': 'name domains',
  '/name-domains/[name]': '%name% domain details',
  '/validators': 'validators list',
  '/gas-tracker': 'Track gas fees',
  '/mud-worlds': 'MUD worlds list',
  '/token-transfers': 'token transfers',
  '/advanced-filter': 'advanced filter',
  '/pools': 'DEX pools',
  '/pools/[hash]': 'pool details',

  // service routes, added only to make typescript happy
  '/login': 'login',
  '/sprite': 'SVG sprite',
  '/api/metrics': 'node API prometheus metrics',
  '/api/monitoring/invalid-api-schema': 'node API prometheus metrics',
  '/api/log': 'node API request log',
  '/api/media-type': 'node API media type',
  '/api/proxy': 'node API proxy',
  '/api/csrf': 'node API CSRF token',
  '/api/healthz': 'node API health check',
  '/api/config': 'node API app config',
  '/api/sprite': 'node API SVG sprite content',
  '/api/website-api-proxy/[...slug]': 'node API website API proxy',
};

const TEMPLATE_MAP_ENHANCED: Partial<Record<Route['pathname'], string>> = {
  '/token/[hash]': '%symbol% token details',
  '/token/[hash]/instance/[id]': 'token instance for %symbol%',
  '/apps/[id]': '%app_name%',
  '/address/[hash]': 'address details for %domain_name%',
  '/stats/[id]': '%title% chart',
};

export function make(pathname: Route['pathname'], isEnriched = false) {
  const template = (isEnriched ? TEMPLATE_MAP_ENHANCED[pathname] : undefined) ?? TEMPLATE_MAP[pathname];
  return pathname === '/' ? `Taostats EVM · ${ template }` : `${ template } · Taostats EVM`;
}
